import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { shouldTranslateTo } from '../utils/utils'
import AwardsCarousel from './AwardsCarousel'
import { logosLink } from './Homepage'
import LogosResponsiveCarousel from './LogosResponsiveCarousel'
import CustomImage from './Utils/CustomImage'
import {
  Title,
  Subtitle,
  CustomSubtitle,
  PrimaryButton,
  PrimaryOutlineButton,
  YouTube,
} from './Utils/CustomClasses'

const Container = styled.div`
  background-color: #fff;
  /* margin-top: 40px; */

  /* @media screen and (max-width: 970px) {
        margin-top: 150px;
    }

    @media screen and (max-width: 768px) {
        margin-top:68px;
    }

    @media screen and (max-width: 767px) {
        margin-top: -15px;
    } */
`

const Header = styled.div`
  background-color: #f6f0e6;
`

const ContainerFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  padding: ${(props) => (props.padding ? props.padding : '0px')};

  ${(props) => props.gray && 'background-color: #F8F9F9'};
  ${(props) => props.background && `background-color: ${props.background}`};

  ${(props) => props.center && 'justify-content: center'};

  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};

  ${(props) => props.dark && 'background-color: #154549'};

  @media screen and (max-width: 1160px) {
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 1160px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '30px')};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }

  @media screen and (max-width: 768px) {
    padding: 5vh 8vw 5vh 8vw;
  }
`

const FixFlexShrink = styled.div`
  flex-grow: 0;
  flex-shrink: 0.5;
  flex-basis: max-content;

  @media only screen and (min-width: 768px) and (max-width: 1160px) {
    flex-basis: max-content !important;

    h1 {
      width: 100%;
    }
  }

  @media screen and (max-width: 1160px) {
    flex-basis: 40vw;
  }
`

const CustomTitle = styled(Title)`
  color: #154549;
  @media screen and (max-width: 600px) {
    font-size: 26px;
    width: 100%;
    margin: 0 0 7px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    width: 100%;
    font-size: 23px;
    line-height: 100%;
  }
`

const CustomTitleH1 = styled(CustomTitle)`
  font-size: 37px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
  @media screen and (min-width: 601px) {
    font-size: 46px;
    line-height: 100%;
  }
`

const GreenTitle = styled(Title)`
  margin: 0 0 28px;

  @media screen and (max-width: 600px) {
    margin: 0 0 36px;
  }
`

const Green = styled.span`
  font-family: 'Lavishly Yours', cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 60px;
  color: #154549;

  @media screen and (max-width: 600px) {
    font-size: 62px;
  }
`

const Button = styled.button`
  border-radius: 5px;
  background: ${(props) => (props.background ? props.background : '#0BAC5D')};
  color: #fff;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 18px;
  font-style: normal;
  line-height: 170%;
  border: none;
  padding: 0;

  a {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    height: 50px;
    vertical-align: middle;
    width: 100%;
    font-weight: 400;
    padding: ${(props) => (props.wider ? '9px 50px' : '9px 65px')};
  }

  @media screen and (max-width: 768px) {
    ${(props) => !props.noFill && `width: -webkit-fill-available;`};
  }
`

const HeaderImage = styled.div`
  ${(props) => (props.fitImage ? 'height: inherit;' : 'height: 100%;')};
  border-radius: 15px;
  text-align: center;
  ${(props) => props.background && 'background-color: #16494D'};

  img {
    width: ${(props) => (props.width ? props.width : '100%')};
    border-radius: 15px;
    ${(props) => props.fitImage && 'object-fit: cover; height: 100%;'}
  }

  @media screen and (max-width: 1025px) {
    img {
      width: ${(props) => (props.widthMd ? props.widthMd : '100%')};
    }
  }

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const Chat = styled.div`
  margin: 0 13vw;
  max-width: 600px;
  background-image: url('/images/homepage-v2/chat-box-2.png');
  background-position: top;
  padding: 32px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -webkit-filter: drop-shadow(0px 6px 13px #919eab29);
  filter: drop-shadow(0px 6px 13px #919eab29);

  h2:first-child {
    font-style: italic;
  }

  @media only screen and (max-width: 600px) {
    padding: 29px 26px;
    margin: 0 0;
  }

  @media only screen and (min-width: 981px) {
    margin: 0 3vw;
  }
`

const SectionMap = styled.div`
  padding: 6vw 6vw 30px 6vw;
  background-image: linear-gradient(#ffeadc, #fff8f2);

  img {
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    padding: 14vw 5vw 30px 5vw;
  }
`

const MapBlock = styled.div`
  margin: 80px 0 0;
  padding: 0 30px;

  @media only screen and (max-width: 980px) {
    margin: 0;
  }
`

const MapText = styled.div`
  margin: auto 0;
  text-align: center;
  padding: 0 50px;

  @media only screen and (max-width: 1024px) {
    padding: 0 25px;
  }

  @media screen and (max-width: 980px) {
    margin-bottom: 25px;
  }

  img {
    width: 50px;
  }
`

const Name = styled.h5`
  color: #16494d;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 140%;
  margin-right: 6px;

  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
`

const Country = styled.h5`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 140%;

  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
`

const FlagDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 35px;

  img {
    width: 29px;
    height: 19px;
    margin-right: 6px;
  }
`

const Sections = styled.div`
  padding: 74px 5vw 30px 5vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  ${(props) => props.last && 'padding: 74px 5vw 40px 5vw;'}

  @media only screen and (max-width: 980px) {
    padding: 32px 3vw 30px 5vw;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 9vw 30px 8vw !important;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }
`

const TravelSection = styled(Sections)`
  padding: 74px 5vw 30px 9vw;
`

const SectionText = styled.div`
  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 6vw auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const SectionTextCircle = styled(SectionText)`
  text-align: center;
  padding: 0 30px;

  @media screen and (max-width: 600px) {
    padding: 0;
  }
`

const SafetySection = styled(Sections)`
  padding: 74px 7vw 30px 8vw !important;
`

const CenterImage = styled.div`
  ${(props) => props.left && 'text-align: left; margin-left: -50px;'}
  img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) {
    ${(props) => props.left && 'margin-left: 0px;'}
  }

  @media only screen and (max-width: 980px) and (min-width: 768px) {
    text-align: center;
    img {
      width: 80%;
    }
  }

  /* margin: auto 0; */
`

const WhatIsSection = styled.div`
  background-color: #f9f3ea;
  padding: 150px 8vw 60px 8vw;

  @media only screen and (max-width: 1280px) {
    padding: 150px 6vw 80px 6vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 100px 10vw 30px 10vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 72px 7vw 30px 7vw;
  }
`

const WhatIsText = styled.div`
  margin: auto 0;
  padding: 0 50px;

  @media only screen and (max-width: 1024px) {
    padding: 0 25px;
  }

  @media screen and (max-width: 980px) {
    margin-bottom: 65px;
    text-align: center;
  }
`

const WhatIsImage = styled.div`
  margin: auto 0vw;
  text-align: center;
  video,
  img {
    width: 100%;
    max-width: 400px;
    border-radius: 15px;

    @media only screen and (max-width: 1024px) {
      max-width: 380px;
    }
  }
`

const AwardsSection = styled.div`
  background-color: #fffbf4;
  text-align: center !important;
  padding: 74px 8vw 80px 8vw;

  @media only screen and (max-width: 600px) {
    text-align: left;
  }
`

const ModSubtitle = styled(Subtitle)`
  line-height: 176%;
`

const Logos = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }

  img {
    max-width: 100%;
  }
`

const TextMembers = styled.div`
  width: 65%;
  margin: 50px auto 0 auto;

  @media only screen and (max-width: 600px) {
    margin: auto 0;

    h1 {
      text-align: left;
      margin-left: 10px;
    }
  }
`

const ImageArrow = styled.img`
  display: ${(props) => (props.mobile ? 'none' : 'block')};
  margin: 0 auto;
  transform: scaleX(-1);
  @media only screen and (max-width: 1024px) {
    width: 40%;
  }

  @media only screen and (max-width: 980px) {
    width: 50%;
    max-width: 160px;
    display: ${(props) => (!props.mobile ? 'none' : 'block')};
    transform: rotate(50deg);
    margin: 25px auto;
  }

  @media only screen and (max-width: 600px) {
  }
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const CircleSection = styled.div`
  padding: 80px 8vw 80px 8vw !important;
  background-color: #fffbf4;

  img {
    width: 100%;
    border-radius: 15px;

    @media only screen and (max-width: 980px) {
      margin-top: 50px;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 34px 5vw 30px 5vw;
  }
`

const DividerSectionDiv = styled.div`
  margin-top: -1px;
  margin-bottom: -1px;
  height: auto;
  /* background-color: red; */

  background-color: ${({ colored }) => (colored ? colored : '#FFFFFF')};

  img {
    width: 100vw;
    ${(props) => (props.flip ? 'transform: rotate(180deg);' : '')}
  }

  /* 
   background-position: right;
   background-size: 110% 100%;
   
   
   width: 100vw; 
   */
`

const PromoVideoSectionLight = styled.div`
  background-color: #f6f0e6;
  padding: 80px 9vw 80px 9vw;

  @media only screen and (max-width: 600px) {
    padding: 50px 9vw 50px 9vw;
  }
`

const FlexRowUnevenPromo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* flex-wrap: wrap; */

  /* > :first-child {
        width: 50%;
    }

    > :last-child {
        width: 50%;
    } */

  @media only screen and (max-width: 1024px) {
    flex-wrap: wrap;
    flex-direction: column;
    > div {
      width: 100% !important;
      /* text-align: center; */
    }
  }
`

const YouTubeContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`

const YouTubeVideo = styled(YouTube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`
const CustomContainerFlexRow = styled(ContainerFlexRow)`
  justify-content: space-evenly;
  align-items: center;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`
const HeaderText = styled.div`
  max-width: 50vw;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    max-width: fit-content;
  }
`
const CustomButtom = styled(Button)`
  margin: 10px 0 0 0;
  padding: 18px 86px;
  a {
    padding: unset;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    margin: 20px 0 30px 0;
  }
`

const SignupLandingPage = () => {
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [pageTextS, setPageTextS] = useState([])
  const [pageTextModalS, setPageTextModalS] = useState([])

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageTextS = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageTextS)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homepage-v2', language, setPageText)
    getPageText('homepage', language, setPageText2)
    getPageText('signup-app', language, setPageTextS)
    getPageText('signup', language, setPageTextModalS)
  }, [])

  const DividerSection = ({ colored, flip }) => {
    return (
      <DividerSectionDiv colored={colored} flip={flip}>
        <img
          src={
            colored
              ? '/images/homepage-v2/divider-colored.svg'
              : '/images/homepage-v2/divider.svg'
          }
        />
      </DividerSectionDiv>
    )
  }

  const DividerSection3 = ({}) => {
    return (
      <DividerSectionDiv>
        <img src={'/images/homepage-v2/divider6.svg'} />
      </DividerSectionDiv>
    )
  }

  const TextChat = () => {
    return (
      <Chat>
        <Subtitle
          color="#154549"
          weight="400"
          size="20px"
          sizemd="1.25rem"
          sizesm="1rem"
          margin="0 0 18px 0"
          dangerouslySetInnerHTML={{
            __html: pageText[48],
          }}
        />
        <FlagDiv>
          <Name>{pageText[49]}</Name>
          <img
            src={'/images/languages/fr.svg'}
            alt={pageText[58]}
            className="flag"
          />
          <Country>{pageText[58]}</Country>
        </FlagDiv>
      </Chat>
    )
  }

  if (pageText.length === 0 || pageText2.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <Header>
        <CustomContainerFlexRow
          gap="50px"
          padding="10vh 40px 10vh 5vw"
          paddingSm="5vh 4vw 5vh 4vw"
        >
          <HeaderText>
            <FixFlexShrink>
              <CustomTitleH1
                size="58px"
                sizemd="58px"
                sizesm="40px"
                dangerouslySetInnerHTML={{
                  __html: `${pageTextS[57]}`,
                }}
              ></CustomTitleH1>
            </FixFlexShrink>

            <FixFlexShrink>
              <CustomTitle
                margin="20px 0 0"
                size="28px"
                sizemd="28px"
                sizesm="20px"
                dangerouslySetInnerHTML={{
                  __html: `${pageTextS[58]}`,
                }}
              ></CustomTitle>
              <GreenTitle>
                <Green>{pageText2[1]}</Green>
              </GreenTitle>
            </FixFlexShrink>

            <Subtitle
              size="1.3rem"
              sizemd="18px"
              margin="30px 0 30px 0"
              marginmd="20px 0 28px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageTextS[59]}`,
              }}
            />

            <Subtitle
              size="1.3rem"
              sizemd="18px"
              margin="0 0 50px 0"
              marginmd="20px 0 28px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageTextS[60]}`,
              }}
            />

            <Link to="/signup-form">
              <CustomButtom>{pageTextS[61]}</CustomButtom>
            </Link>
          </HeaderText>
          <HeaderImage>
            <img src={'/images/facebook-host/header.jpg'} />
          </HeaderImage>
        </CustomContainerFlexRow>
      </Header>

      {/* What is Freebird Club? */}
      <SectionMap>
        <FlexRow reverse>
          <MapBlock>
            <TextChat />
            <img src="/images/homepage-v2/map.png" />
          </MapBlock>
          <MapText>
            <Subtitle
              weight="600"
              color="#154549"
              size="20px"
              sizemd="1.5rem"
              sizesm="20px"
              margin="0 0 40px 0"
              marginsm="0 0 20px 0"
              dangerouslySetInnerHTML={{ __html: pageText[66] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="50px"
              sizemd="3rem"
              sizesm="31px"
              dangerouslySetInnerHTML={{ __html: pageText[17] }}
            />
            <ImageArrow src="/images/homepage-v2/arrow.svg" />
            <Subtitle
              color="#154549"
              weight="400"
              size="20px"
              sizemd="1.25rem"
              sizesm="20px"
              margin="30px 0 30px 0"
              marginmd="30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[53] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="20px"
              margin="30px 0 50px 0"
              marginsm="30px 0 40px"
              dangerouslySetInnerHTML={{ __html: pageText[18] }}
            />
            <Link to="/signup-form">
              <PrimaryButton>
                <a>{pageText[19]}</a>
              </PrimaryButton>
            </Link>

            <ImageArrow mobile src="/images/homepage-v2/arrow.svg" />
          </MapText>
        </FlexRow>
      </SectionMap>
      {/* Divider */}
      <DividerSection3 colored={'#ffccff'} flip={false} />
      {/* Travel / Homestays */}
      <TravelSection>
        <FlexRow reverse gapSm="58px">
          <CustomImageWrapper>
            <CustomImage
              imageBig={'/images/homepage-v2/nicola-big.png'}
              imageSmall={'/images/homepage-v2/nicola-small.png'}
              name={pageText[41]}
              text={pageText[42]}
              country={pageText[59]}
              countryFlag={'en'}
            />
          </CustomImageWrapper>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[6] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              marginsm="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[7] }}
            />
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[8] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[9] }}
            />
          </SectionText>
        </FlexRow>
      </TravelSection>
      {/* Community / Events */}
      <Sections last>
        <FlexRow gapSm="45px" gap="10px">
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[11] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              marginsm="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[12] }}
            />
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[13] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[14] }}
            />

            <Link to="/signup-form">
              <PrimaryOutlineButton>
                <a>{pageText[15]}</a>
              </PrimaryOutlineButton>
            </Link>
          </SectionText>
          <CenterImage left>
            <img src="/images/homepage-v2/community3.png" />
          </CenterImage>
        </FlexRow>
      </Sections>

      {/* Divider */}
      <DividerSection colored={'#ffffff'} flip={false} />
      {/* Awards */}
      <AwardsSection>
        <CustomSubtitle
          color="#154549"
          size="21px"
          sizemd="1.25rem"
          sizesm="20px"
          margin="0 0 50px 0"
          dangerouslySetInnerHTML={{ __html: pageText[20] }}
        />
        <AwardsCarousel />
      </AwardsSection>

      {/* Trust & Security / ID */}
      <SafetySection>
        <FlexRow gap="50px">
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[21] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[22] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[23] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[24] }}
            />
          </SectionText>
          <CustomImageWrapper>
            <CustomImage
              imageBig={'/images/homepage-v2/marie-big.jpg'}
              imageSmall={'/images/homepage-v2/marie-small.jpg'}
              name={pageText[43]}
              text={pageText[44]}
              country={pageText[57]}
              countryFlag={'ie'}
            />
          </CustomImageWrapper>
        </FlexRow>
      </SafetySection>
      {/* Value Build / Pay */}
      <Sections>
        <FlexRow reverse>
          <CenterImage>
            <img src="/images/homepage-v2/real2.png" />
          </CenterImage>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[25] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[26] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[27] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[28] }}
            />
          </SectionText>
        </FlexRow>
      </Sections>
      {/* Divider */}
      <DividerSection colored={'#ffffff'} flip={false} />
      {/* Circle */}
      <CircleSection>
        <FlexRow>
          <SectionTextCircle>
            <Title
              center
              color="#154549"
              margin="0 0 30px 0"
              size="38px"
              sizemd="2.5rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[54] }}
            />
            <Subtitle
              center
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.15rem"
              sizesm="18px"
              margin="0 0 30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[55] }}
            />
            <Link to="/signup-form">
              <PrimaryButton>
                <a>{pageText[19]}</a>
              </PrimaryButton>
            </Link>
          </SectionTextCircle>
          <div>
            <img src="/images/homepage-v2/circle2.png" />
          </div>
        </FlexRow>
      </CircleSection>
      {/* Divider */}
      {/* Promo video */}
      <PromoVideoSectionLight>
        <FlexRowUnevenPromo>
          <Subtitle
            center
            weight="300"
            color="#154549"
            size="22px"
            sizemd="20px"
            sizesm="18px"
            margin="0 0 50px 0"
            marginsm="0 8px 20px 8px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[47]}`,
            }}
          />

          <YouTubeContainer>
            <YouTubeVideo
              src={`https://www.youtube.com/embed/8YAeceFIvf8?si=IvSvEwZXHKyt2cg_`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            ></YouTubeVideo>
          </YouTubeContainer>
        </FlexRowUnevenPromo>
      </PromoVideoSectionLight>

      {/* Logos */}
      <Logos padding="10vh 7vw 10vh 7vw">
        <Title
          center
          color="#154549"
          size="35px"
          sizemd="2rem"
          sizesm="23px"
          margin="0 0 30px 0"
          smCenter
          dangerouslySetInnerHTML={{
            __html: pageText[40],
          }}
        ></Title>
        <LogosResponsiveCarousel logosLink={logosLink} />
      </Logos>
    </Container>
  )
}
export default SignupLandingPage
